module.exports = __webpack_public_path__ + "static/media/shahryar.d7c80d96.png";